import Loading from "./Loading"

export interface Props {
  contrast?: boolean
  disabled?: boolean
  secondary?: boolean
  size?: number
}

export interface ComponentProps extends Props {}

export default Loading
